import React from 'react';
import './ObjectCard.css';

const ObjectCard = ({ 
  id,
  icon, 
  title, 
  description, 
  lastUpdated,
  isEnabled=true,
  onClick,
  onToggle,
  variant = 'default',
  showToggle = true,
  tags = []
}) => {
  const handleClick = (e) => {
    // Evitar que el click del toggle dispare el onClick del card
    if (!e.target.closest('.config-card-toggle')) {
      onClick && onClick(id);
    }
  };

  const handleToggle = (e) => {
    e.stopPropagation();
    onToggle && onToggle(id, !isEnabled);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick && onClick(id);
    }
  };

  const formatDate = (date) => {
    if (!date) return 'Sin actualizar';
    
    const now = new Date();
    const updateDate = new Date(date);
    const diffTime = Math.abs(now - updateDate);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
    
    if (diffDays === 0) return 'Actualizado hoy';
    if (diffDays === 1) return 'Actualizado ayer';
    if (diffDays < 7) return `Hace ${diffDays} días`;
    if (diffDays < 30) return `Hace ${Math.floor(diffDays / 7)} semanas`;
    if (diffDays < 365) return `Hace ${Math.floor(diffDays / 30)} meses`;
    
    return updateDate.toLocaleDateString('es-ES', { 
      day: 'numeric',
      month: 'short',
      year: updateDate.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
    });
  };

  return (
    <div 
      className={`config-card ${variant} ${!isEnabled ? 'disabled' : ''} ${onClick ? 'clickable' : ''}`}
      onClick={handleClick}
      onKeyPress={handleKeyPress}
      tabIndex={onClick ? 0 : -1}
      role="button"
      aria-label={`${title}: ${description}. Estado: ${isEnabled ? 'Habilitado' : 'Deshabilitado'}`}
      data-id={id}
    >
      <div className="config-card-header">
        <div className="config-card-icon">
          {typeof icon === 'string' ? (
            <span className="icon-emoji">{icon}</span>
          ) : (
            icon
          )}
        </div>
        
        <div className="config-card-content">
          <div className="config-card-title-row">
            <h3 className="config-card-title">{title}</h3>
            <span className={`status-badge ${isEnabled ? 'active' : 'inactive'}`}>
              {isEnabled ? 'Activo' : 'Inactivo'}
            </span>
          </div>
          
          {description && (
            <p className="config-card-description">{description}</p>
          )}
          
          <div className="config-card-footer">
            <div className="config-card-meta">
              {tags && tags.length > 0 && (
                <div className="config-card-tags">
                  {tags.map((tag, index) => (
                    <span key={index} className="config-tag">{tag}</span>
                  ))}
                </div>
              )}
              
              <div className="config-card-date">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                  <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.5"/>
                  <polyline points="12,6 12,12 16,14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                <span>{formatDate(lastUpdated)}</span>
              </div>
            </div>
            
            {showToggle && (
              <button
                className="config-card-toggle"
                onClick={handleToggle}
                aria-label={`${isEnabled ? 'Desactivar' : 'Activar'} ${title}`}
                type="button"
              >
                <label className="toggle-switch">
                  <input 
                    type="checkbox" 
                    checked={isEnabled}
                    onChange={() => {}}
                    tabIndex="-1"
                  />
                  <span className="toggle-slider"></span>
                </label>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ObjectCard;